import React from 'react';
import PropTypes from 'prop-types';
import Title from '@/shared/ui/elements/title/Title';
import Label from '@/shared/ui/elements/label/Label';
import SelectField from '@/shared/ui/elements/select/Select';
import { getModifiers } from '@/shared/ui/core';
import {
  SelectGroupBy,
  Select,
  Placeholder,
  SelectOverlay,
  IconWrapper,
  Option,
} from './SelectGroupBy.styled';

import IconChevronDown from '@/shared/assets/icons/icon-chevron-down.svg';

const labelModifiers = ['default', 'required'];

export default ({ name, options, outLabel, placeholder, onChange, modifiers, ...props }) => {
  const selectRef = React.useRef(null);

  const optionsGroupedBy = React.useMemo(() => {
    const newOptions = {};

    options.forEach((option) => {
      if (!newOptions[option.groupName]) {
        newOptions[option.groupName] = [];
      }

      newOptions[option.groupName].push(option);
    });

    return newOptions;
  }, [options]);

  const handleSelect = React.useCallback(
    (event) => {
      onChange(event);
      selectRef.current.removeAttribute('open');
    },
    [selectRef?.current],
  );

  return (
    <SelectGroupBy>
      {outLabel && (
        <Label
          content={outLabel}
          modifiers={getModifiers(props, labelModifiers)}
        />
      )}
      <Select ref={selectRef} {...props}>
        <Placeholder>
          <SelectField name={name} options={options} placeholder={placeholder} readOnly />
          <IconWrapper>
            <IconChevronDown />
          </IconWrapper>
        </Placeholder>
        <SelectOverlay>
          {Object.entries(optionsGroupedBy).map(([key, list]) => (
            <React.Fragment key={key}>
              <Title
                as="span"
                content={key.toLowerCase()}
                modifiers={['primary', 'capitalize']}
              />
              {list?.map((option) => (
                <Option
                  key={option.value}
                  value={option.value}
                  onClick={(event) => handleSelect(event, option.label)}
                >
                  {option.label}
                </Option>
              ))}
            </React.Fragment>
          ))}
        </SelectOverlay>
      </Select>
    </SelectGroupBy>
  );
};

SelectGroupBy.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      groupName: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]).isRequired,
    }),
  ),
  placeholder: PropTypes.string,
  outLabel: PropTypes.string,
  modifiers: PropTypes.arrayOf(PropTypes.string),
};

SelectGroupBy.defaultProps = {
  options: [],
  placeholder: '',
  outLabel: '',
  modifiers: [''],
};
